module.exports = __webpack_public_path__ + "media/images/flags/64/Montserrat-a9fc5908ecc8d48547751d695e3d8815.png";